import { render, staticRenderFns } from "./DocumentForm.vue?vue&type=template&id=d49b6b52"
import script from "./DocumentForm.vue?vue&type=script&lang=ts"
export * from "./DocumentForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports